import { RefObject } from "react";
import { getBreakpoints } from "@core/utils/getBreakpoints";
import useContainerDimensions from "./useContainerDimensions";

export const useContainerWidthBreakpoint = (ref: RefObject<HTMLDivElement>) => {
  const breakpoints = getBreakpoints();

  const { width: containerWidth, height: containerHeight } =
    useContainerDimensions<HTMLDivElement>(ref);

  const isXs = containerWidth >= breakpoints.xs;
  const isSm = containerWidth >= breakpoints.sm;
  const isMd = containerWidth >= breakpoints.md;
  const isLg = containerWidth >= breakpoints.lg;
  const isXl = containerWidth >= breakpoints.xl;
  const is2xl = containerWidth >= breakpoints["2xl"];

  return {
    containerWidth,
    containerHeight,
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    is2xl,
  };
};

export default useContainerWidthBreakpoint;

